module.exports = __webpack_public_path__ + "static/media/stockStep03.273f3d76.png";